import React from 'react'
import PrimaryGradientButton from './PrimaryGradientButton'
import PrimaryOutLineButton from './PrimaryOutLineButton'
import { Col, Row } from 'react-bootstrap'

const EventCard = ({ descriptionDetails, isEventList, onClickReadMore, onClickViewDetails, onClick, eventStartTime, eventEndTime, eventType, image, eventTitle, calenderImage, locationPin, eventTime, eventPlace, eventDesc, isnewsLetter, setIsnewsLetter, item }) => {
  return (
    <>
      <div className='upComingCard'>
       
          <div className='upcomingImg'>
            <img src={image} alt='image' className='img-fluid' />
          </div>
       

        <div className='eventTitleBlock'><p className='eventTitle'>{eventTitle}</p></div>

        <div className='mt-3'>
          <div className='upComingEventTime'>
            <img src={calenderImage} alt='image' /> <b>Start:</b> {eventStartTime}
          </div>
          <div className='upComingEventTime'>
            <img src={calenderImage} alt='image' /> <b>End:</b> {eventEndTime}
          </div>
        </div>
        <div className='upComingEventPlace'>
          <img src={locationPin} alt='image' /><b>Place:</b> {eventPlace}
        </div>

        <div className='upcomingEventDesc'>

          <p className='eventType mb-2'><b>Event Type:</b> {eventType}</p>
          <p className='mb-0'>Click READ MORE to see details</p>
        </div>

        <div className='upComingEventBtnWrapBlock mt-2'>

          {!isEventList &&
            <PrimaryGradientButton buttonText="Read More" onClick={onClickViewDetails} />
          }
          {isEventList &&

            <Row>
              <Col xs={12}><p>{descriptionDetails}</p></Col>
              <Col xs={12} lg={6}><PrimaryOutLineButton outlinebuttonText="Read More" onClick={onClickReadMore} /></Col>
              <Col xs={12} lg={6}>
                {!item.isParticipated && <PrimaryGradientButton buttonText="Interested to Participate" onClick={onClick} />}
                {item.isParticipated && <PrimaryGradientButton disabled={true} buttonText="Shown Interest" onClick={onClick} />}
              </Col>
            </Row>

          }

        </div>
      </div>
    </>
  )
}

export default EventCard